import $ from 'jquery';
import assign from 'lodash/assign';
import throttle from 'lodash/throttle';

import './slick-carousel'; // Import side-effect module

const defaultSettings = { slideshowSettings: {} };
const offsetLoadY = 100;

function checkScroll(settings, $slideshows) {
  const $window = $(window);
  const totalSlideshows = $slideshows.length;
  let slideshowIteratorCount = 0;

  $slideshows.each(function () {
    const $slideshow = $(this);
    if ($slideshow.attr('lazyTriggered') === 'false') {
      const y = $slideshow.offset().top;
      const visibleY = $window.scrollTop() + $window.innerHeight();
      if (y < visibleY + offsetLoadY) {
        $slideshow.removeClass('js-lazyload-slick');
        $slideshow.slick(settings.slideshowSettings);
        $slideshow.attr('lazyTriggered', true);
      }
    } else {
      slideshowIteratorCount += 1;
    }
  });

  if (slideshowIteratorCount === totalSlideshows) {
    $(window).off('scroll.lazyloadSlideshow resize.lazyloadSlideshow');
  }
}

function init(userSettings) {
  const $slideshows = $('.js-lazyload-slick');
  const settings = assign({}, defaultSettings, userSettings);
  $slideshows.attr('lazyTriggered', false);

  $(window).on(
    'scroll.lazyloadSlideshow resize.lazyloadSlideshow',
    throttle(() => {
      checkScroll(settings, $slideshows);
    }, 100)
  );

  checkScroll(settings, $slideshows);
}

// Default export
export default init;




// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/lazyload.js